// plugins
import './plugins/vee-validate'
import './plugins/vue-select'
import './plugins/vue-slider'
import './plugins/vue-good-table'

// forms
Vue.component('c-input', require('./ui/forms/c-input').default)
Vue.component('c-textarea', require('./ui/forms/c-textarea').default)
Vue.component('c-datepicker', require('./ui/forms/c-datepicker').default)
Vue.component('c-select', require('./ui/forms/c-select').default)
Vue.component('c-checkbox', require('./ui/forms/c-checkbox').default)
Vue.component('c-editor', require('./ui/forms/c-editor').default)
Vue.component('c-datepicker', require('./ui/forms/c-datepicker').default)
Vue.component('c-radio', require('./ui/forms/c-radio').default)
Vue.component('c-radio-group', require('./ui/forms/c-radio-group').default)
Vue.component('c-checkbox-group', require('./ui/forms/c-checkbox-group').default)
Vue.component('c-upload', require('./ui/forms/c-upload').default)
Vue.component('c-button', require('./ui/forms/c-button').default)
Vue.component('c-button-help', require('./ui/forms/c-button-help').default)
Vue.component('c-button-link', require('./ui/forms/c-button-link').default)
Vue.component('c-input-group', require('./ui/forms/c-input-group').default)
Vue.component('c-icon-background', require('./ui/icons/c-icon-background').default)

Vue.component('c-sidebar', require('./components/c-sidebar').default)
Vue.component('c-spinner', require('./ui/components/Spinner').default)
Vue.component('c-loader', require('./ui/components/Loader').default)
Vue.component('c-clipboard-btn', require('./ui/components/ClipboardBtn').default)
Vue.component('c-list-error', require('./ui/components/ListError').default)
Vue.component('c-list-empty', require('./ui/components/ListEmpty').default)
Vue.component('header-with-help-button', require('./ui/components/HeaderWithHelpButton').default)
Vue.component('c-sortable-item', require('./ui/components/SortableItem').default)

Vue.component('c-modal', require('./ui/modals/c-modal').default)
Vue.component('c-confirm-delete-modal', require('./ui/modals/c-confirm-delete-modal').default)
Vue.component('items-crud-list', require('./ui/components/ItemsCrudList').default)
Vue.component('item-crud', require('./ui/components/ItemCrud').default)
Vue.component('preview-email-content', require('./ui/components/PreviewEmailContent').default)
Vue.component('block-flat', require('./ui/components/BlockFlat').default)
Vue.component('event-form-builder-form', require('./shared/event-form-builder-form').default)
